import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {OkCancelController} from '../../../core/dialog/OkCancelController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import ErrorService from '../../../core/errors/service/ErrorService';
import InspektoratRS from '../../../core/service/InspektoratRS.rest';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import RoleUtilService from '../../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import AbstractModelManagerController from '../../../gesuch/component/abstractModelManagerController';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import {getKantonCodeList, TSKantonCode} from '../../../models/enums/TSKantonCode';
import TSAnlaufstelle from '../../../models/TSAnlaufstelle';
import TSBenutzer from '../../../models/TSBenutzer';
import TSInspektorat from '../../../models/TSInspektorat';
import DVBernUtil from '../../../utils/DVBernUtil';
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;

let template = require('./inspektoratView.html');
let okCancelTemplate = require('../../../core/dialog/okCancelTemplate.html');
require('./inspektoratView.scss');

export class InspektoratViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = InspektoratViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        inspektorat: '<'
    };
}

export class InspektoratViewController extends AbstractModelManagerController<TSInspektorat> {

    inspektorat: TSInspektorat;
    form: IFormController;
    anlaufstelleToAdd: TSAnlaufstelle | undefined;
    inspektorToAdd: TSBenutzer | undefined;
    inspektorenList: Array<TSBenutzer>;
    createNew: boolean = true;
    disableVerwalterselection: boolean;
    doctype: TSDocumentType = TSDocumentType.ANLAUFSTELLE_DOC;

    static $inject = ['DVBernUtil', '$q', '$scope', '$log', '$state', 'InspektoratRS', 'PasswordStrengthService',
        'ErrorService', 'SchadenfallModelManager', 'RoleUtilService', 'AuthServiceRS', 'DvDialog'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil,
                private  $q: IQService,
                $scope: IScope, private $log: ILogService,
                private $state: IStateService, private inspektoratRS: InspektoratRS,
                private passwordStrengthService: PasswordStrengthService,
                private errorService: ErrorService, schadenfallModelManager: SchadenfallModelManager,
                private roleUtilService: RoleUtilService, private authService: AuthServiceRS,
                private dvDialog: DvDialog) {
        super(schadenfallModelManager, $scope, $state.current.name);
        // super();
    }

    $onInit() {
        super.$onInit();
        if (this.inspektorat.id) {
            this.createNew = false;
        }
        if (this.authService.isOneOfRoles(this.roleUtilService.getAdministratorRoles()) || this.inspektorat.verwalter === undefined) {
            this.disableVerwalterselection = false;
        } else {
            this.disableVerwalterselection = true;
        }
        this.initialModel = this.inspektorat;
        this.model = angular.copy(this.inspektorat);
    }

    public save() {
        if (this.isModelValid() && this.model) {

            this.inspektoratRS.createOrUpdate(this.model).then((response: TSInspektorat) => {
                this.$state.go('inspektoratverwaltung');
            });

        } else {
            this.$log.debug('Form was not valid');
        }
    }

    /**
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    public isModelValid(): boolean {
        if (!this.form.$valid) {
            DVBernUtil.focusFirstInvalidInput()
        }
        return this.form.$valid;
    }

    public addAnlaufstelle() {
        if (this.anlaufstelleToAdd) {
            this.model.anlaufstellen.push(this.anlaufstelleToAdd);
        }
        this.anlaufstelleToAdd = undefined;
    }

    deleteClicked(anlaufstelleToDelete: TSAnlaufstelle, event: any) {
        let index = DVBernUtil.getIndexOfElementwithID(anlaufstelleToDelete, this.model.anlaufstellen);
        if (index > -1) {
            this.model.anlaufstellen.splice(index, 1);
        }
    }

    public cancel() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('inspektoratverwaltung');
    }

    public kantonList(): Array<TSKantonCode> {
        return getKantonCodeList()
    }

    public translateKanton(kantonCode: TSKantonCode): string {
        return TSKantonCode[kantonCode];
    }

    private getInspektoren(): Array<TSBenutzer> {
        return this.getModel().inspektoren;
    }

    private setInspektoren(collectionOfSB: Array<TSBenutzer>) {
        this.getModel().inspektoren = collectionOfSB;
    }

    public addInspektor() {
        if (this.inspektorToAdd) {
            this.getInspektoren().push(this.inspektorToAdd);
        }
        this.inspektorToAdd = undefined;
    }

    public removeInspektor(benutzer: TSBenutzer, event: any) {
        if (benutzer) {
            let arrWithoutEle = this.getInspektoren().filter(currentBen => currentBen !== benutzer);
            this.setInspektoren(arrWithoutEle)

        }

    }

    public enableVerwalterselection() {
        let text = 'CONFIRM_VERWALTERCHANGE';
        this.dvDialog.showDialog(okCancelTemplate, OkCancelController,
            {text: text})
            .then(() => {   //User confirmed removal
                this.disableVerwalterselection = false;
            })
            .catch(() => {
            });

    }

}



// WEBPACK FOOTER //
// ./src/app/inspektoratverwaltung/component/inspektoratView/inspektoratView.ts